import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { TrsReferenceVoucherKind } from "./trs-reference-voucher-kind.model";
import { TrsVoucherKindConcern } from "./trs-voucher-kind-concern.model";
import { TrsVoucherKindDetailLedgerKind } from "./trs-voucher-kind-detail-ledger-kind.model";
import { TrsVoucherKindTreasuryDetailLedgerKind } from "./trs-voucher-kind-treasury-detail-ledger-kind.model";

export class TrsVoucherKind extends EntityBase {
  public Code: number;

  public Active: boolean;

  public SubledgerInHeader: boolean;

  public TreasuryDetailLedgerInHeader: boolean;

  public DetailLedgerInHeader: boolean;

  public Title: string;

  public LatinTitle: string;

  public DetailLedgerCaption: string;

  public RequireDetailLedger: boolean;

  public IsCheckBook: boolean;
  public Guarantee: boolean;

  public IsEstablishment: boolean;

  public DocumentKindId: number;

  public DocumentKindCode?: number;

  public DocumentKindTitle: string;

  public ShowTreasuryRemainPrice: boolean;

  public HasDeliverDate: boolean;

  public ConcernInHeader: boolean;

  public EffectKindId: number;

  public EffectKindCode?: number;

  public EffectKindTitle: string;

  public OrderByNumber: number;

  public HasRelatedRestaurantSell: boolean;

  public OperationKindId: number;
  public OperationKindCode?: number;

  public OperationKindTitle: string;

  public ReferenceVoucherKindIsRequired: boolean;

  public HasJournalVoucher: boolean;

  public HasJournalVoucherAuto: boolean;

  public HasCheckPrint: boolean;

  public HasCheckVoucherDate: boolean;

  public ToDayDate: boolean;

  public HasAutoConfirm: boolean;

  public ShowSubLedger: boolean;

  public DefaultSubLedgerId?: number;

  public DefaultSubLedgerCode?: number;

  public DefaultSubLedgerTitle: string;

  public HasSMS: boolean;

  public CompanyNameInSMS: boolean;

  public ShowDocumentNo: boolean;

  public DocumentNoCaption: string;

  public DocumentDateCaption: string;

  public RequireDocumentNo: boolean;

  public ShowBank: boolean;

  public BankCaption: string;

  public RequireBank: boolean;

  public ShowTreasuryDetailLedger: boolean;

  public TreasuryDetailLedgerCaption: string;

  public RequireTreasuryDetailLedger: boolean;

  public Comment: string;

  public LatinComment: string;

  public DefaultOppositSubLedgerId: number;

  public DefaultOppositSubLedgerCode: number;

  public DefaultOppositSubLedgerTitle: string;

  public ShowBranchCode: boolean;

  public BranchCodeCaption: string;

  public BranchTitleCaption: string;

  public RequireBranchCode: boolean;

  public ShowTag1: boolean;

  public TagCaption1: string;

  public RequireTag1: boolean;

  public ShowTag2: boolean;

  public TagCaption2: string;

  public RequireTag2: boolean;

  public ShowTag3: boolean;

  public TagCaption3: string;

  public RequireTag3: boolean;

  public ShowTag4: boolean;

  public TagCaption4: string;

  public RequireTag4: boolean;

  public ShowTag5: boolean;

  public TagCaption5: string;

  public RequireTag5: boolean;

  public ShowTag6: boolean;

  public TagCaption6: string;

  public RequireTag6: boolean;

  // public TreasuryDetailLedgerInLevelId?: number;

  public DetailLedgerInLevelId?: number;

  public IsBasedVerifiedDocuments: boolean;
  public TrsReferenceVoucherKinds: TrsReferenceVoucherKind[];
  public TrsVoucherKindConcerns: TrsVoucherKindConcern[];
  public TrsVoucherKindDetailLedgerKinds: TrsVoucherKindDetailLedgerKind[];
  public TrsVoucherKindTreasuryDetailLedgerKinds: TrsVoucherKindTreasuryDetailLedgerKind[];
}
